import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { Close } from 'blaze-ui/icons'
import { Text } from 'blaze-ui/Text/Text'
import Styles from './ContentRating.module.scss'
import { useState } from 'react'
import { Button } from 'blaze-ui/Button'
import { Input } from 'almanac-ui/TextInputField/Input'
import cx from 'classnames'
import { Feedback } from 'types'
import { PressEvent } from '@react-types/shared/src/events'
import { FeedbackChips } from './FeedbackChips'

interface DownvoteProps {
  showTellUsMore: boolean
  setShowTellUsMore: (show: boolean) => void
  extraFeedback: string
  setExtraFeedback: (feedback: string) => void
  onSubmit: (feedback: string) => void
  onChipPress: (e: PressEvent) => void
  localFeedback?: Feedback
  onClose: () => void
  className?: string
}

export const Downvote = ({
  showTellUsMore,
  setShowTellUsMore,
  extraFeedback,
  setExtraFeedback,
  localFeedback,
  onClose,
  onSubmit,
  onChipPress,
  className,
}: DownvoteProps) => {
  const [showMore, setShowMore] = useState(false)

  return (
    <div className={cx(Styles.root, Styles.downvoteFeedback, className)}>
      {showTellUsMore ? (
        <>
          <div className={Styles.closeButton}>
            <IconButton
              aria-label="Back"
              onPress={onClose}
              icon={() => <Close size={16} />}
              variant="tertiary"
              size="sm"
            />
          </div>
          <Text variant="secondary">What could be improved?</Text>
          <Input
            isTextarea
            rows={3}
            placeholder="Tell us more"
            name="tell-us-more"
            autoFocus
            value={extraFeedback}
            onChange={(e) => setExtraFeedback(e.target.value)}
          />
          <div className={Styles.submitButtons}>
            <Button aria-label="Submit" onPress={() => setShowTellUsMore(false)} size="sm" variant="secondary">
              Back
            </Button>
            <Button aria-label="Submit" onPress={() => onSubmit(extraFeedback)} size="sm">
              Send Feedback
            </Button>
          </div>
        </>
      ) : (
        <>
          <div className={Styles.closeButton}>
            <IconButton
              aria-label="Back"
              onPress={onClose}
              icon={() => <Close size={16} />}
              variant="tertiary"
              size="sm"
            />
          </div>
          <Text variant="secondary">What could be improved?</Text>
          {localFeedback && (
            <FeedbackChips
              feedback={localFeedback}
              onChipPress={onChipPress}
              onOtherPress={() => setShowTellUsMore(true)}
              setShowMore={setShowMore}
              showMore={showMore}
            />
          )}
          <div className={Styles.submitButton}>
            <Button aria-label="Submit" onPress={onClose} size="sm">
              Send Feedback
            </Button>
          </div>
        </>
      )}
    </div>
  )
}
